import { IOutfits } from "./outfit.model";

export class OutfitSelectedModel {
  constructor(data = {}) {
    this[IOutfits.id] = data[IOutfits.id];
    this[IOutfits.colorId] = data[IOutfits.colorId];
  }

  getId() {
    return this[IOutfits.id];
  }

  getLabel() {
    return this[IOutfits.label];
  }

  getColor() {
    return this[IOutfits.colorId];
  }
}
